import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import SectionRenderer from "../components/SectionRenderer";

export default function PublicPage({ slug }) {
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null);
    setNotFound(false);
    api.get(`/public/pages/${slug}`)
      .then(({ data }) => {
        setPage(data);
        document.title = data.metaTitle || `${data.title} | LD Travel`;
        let meta = document.querySelector("meta[name='description']");
        if (meta && data.metaDescription) meta.setAttribute("content", data.metaDescription);
        window.scrollTo(0, 0);
      })
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <main className="min-h-[60vh] flex items-center justify-center">
        <div className="text-center px-4">
          <h1 className="font-heading text-4xl text-[#0B1D3A] font-semibold">Page not found</h1>
          <p className="text-slate-500 mt-3">The page you're looking for doesn't exist.</p>
        </div>
      </main>
    );
  }

  if (!page) {
    return (
      <main className="min-h-[80vh] bg-[#061325] flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-amber-400/30 border-t-amber-400 rounded-full animate-spin" aria-label="Loading" />
      </main>
    );
  }

  return (
    <main data-testid={`page-${slug}`}>
      <SectionRenderer sections={page.sections} />
    </main>
  );
}
